import Animation from './animation'
import * as d3 from 'd3-selection'
import { interpolate } from 'd3-interpolate'
import * as shape from 'd3-shape'

/*
 * Used when a breakdown is removed from a line. All the current
 * points converge to the new centered point
 */
class RemoveBreakdownAnimation extends Animation {

  match (serie) {
    if (!this.previous.scalers.x || this.seriesChanged) {
      // We don't have previous data or series changed, so we're not sliding
      return false
    }

    return !this.chart.previous.layout.breakdown.calculated && // Previously didn't have a calculated breakdown
           this.chart.layout.breakdown.calculated  // Now we do
  }

  animate (serie, entering, selection, merged, exiting) {
    // All the points converge to a single point
    // Get the new center point
    let self = this
      , endCoords = { // By definition of no-breakdown data, we know there's a single point
        x: this._scalerX(this.scalers.x)(),
        y0: this.yScale(serie.points[0]._range[0]),
        y1: this.yScale(serie.points[0]._range[1])
      }
      , points = this._getPreviousPointsByRange(selection.selectAll('.point').data()) // Previous dom data location

    merged.selectAll('.point')
          .tween('move', function (d) {
            let interpolateX = interpolate(self.previous.scalers.x.center(d.rangeId), endCoords.x)
              , interpolateY0 = interpolate(self.previous.yScale(d._range[0]), endCoords.y0)
              , interpolateY1 = interpolate(self.previous.yScale(d._range[1]), endCoords.y1)

            return self._tweenPoint(this, points, interpolateX, interpolateY0, interpolateY1)
          })
          .end().then(() => {
            // Done transitioning, properly bind the data

            // Update the points...
            // Notice for the scale0 parameter we're passing in the current xScale.
            // That's because the new (only) point we're showing doesn't have a `rangeId` and all the point data
            // is key'd off `rangeId`. We want it to start at its final location, which will be the center.
            this._points(selection, {
              x: this._scalerX(this.scalers.x),
              y: this.yScale
            })

            // Now update the paths
            this._rebindPaths(selection, serie.points)
          })
  }

}

export default RemoveBreakdownAnimation
